import { render } from "./TradeDropdown.vue?vue&type=template&id=3ec9bcf3"
import script from "./TradeDropdown.vue?vue&type=script&lang=js"
export * from "./TradeDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script